import { Box } from '@mui/material';
import { LoadingSkeleton, FormTitleBox } from '../../../common/components';
import AddIcon from '@mui/icons-material/Add';

// Componentes separados
import TaskTemplatesFilters from './components/TaskTemplatesFilters';
import TaskTemplatesDataTable from './components/TaskTemplatesDataTable';
import TaskTemplatesPagination from './components/TaskTemplatesPagination';
import TaskTemplateDialog from './components/TaskTemplateDialog';
import TasksViewDialog from './components/TasksViewDialog';

// Hook personalizado
import { useTaskTemplatesTable } from './hooks/useTaskTemplatesTable';

/**
 * Componente principal para gestionar plantillas de tareas
 * Refactorizado para usar TanStack Query y seguir los patrones del proyecto
 */
const TaskTemplatesTable = () => {
  const {
    // Estados de datos
    data,
    isLoading,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    filter,

    // Estados de diálogos
    dialogOpen,
    tasksDialogOpen,
    selectedTemplate,
    editMode,

    // Funciones de manejo
    handleFilter,
    handlePageChange,
    handleRowsPerPageChange,
    handleOpenCreateDialog,
    handleOpenEditDialog,
    handleOpenTasksDialog,
    handleCloseDialog,
    handleCloseTasksDialog,
    handleSaveTemplate,
    handleDeleteTemplate,
  } = useTaskTemplatesTable();

  if (isLoading) { return <LoadingSkeleton />; }

  return (
    <>
      <Box>
        <FormTitleBox
          title="Obra | Seguimiento | Dashboard"
          showButton={true}
          buttonText="Nueva plantilla"
          buttonIcon={AddIcon}
          onButtonClick={handleOpenCreateDialog}
        />
        
        <TaskTemplatesFilters
          filter={filter}
          onFilter={handleFilter}
        />

        <TaskTemplatesDataTable
          data={data}
          isLoading={isLoading}
          onEdit={handleOpenEditDialog}
          onViewTasks={handleOpenTasksDialog}
          onDelete={handleDeleteTemplate}
          LoadingComponent={LoadingSkeleton}
        />

        <TaskTemplatesPagination
          totalPages={totalPages}
          totalCount={totalCount}
          page={page}
          onPageChange={handlePageChange}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      </Box>

      <TaskTemplateDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        onSave={handleSaveTemplate}
        selectedTemplate={selectedTemplate}
        editMode={editMode}
      />

      <TasksViewDialog
        open={tasksDialogOpen}
        onClose={handleCloseTasksDialog}
        template={selectedTemplate}
      />
    </>
  );
};

export default TaskTemplatesTable;
